/**
 * Browser-local history of cards dealt across recent games, so the dealer
 * can prefer unseen cards for roughly the first 5 plays on a device.
 */

const STORAGE_KEY = 'dealtHistory';
export const HISTORY_GAME_LIMIT = 5;

function historyKey(departmentId, isDemo) {
  const dep = departmentId == null || departmentId === '' ? 'all' : String(departmentId);
  return `${dep}:${isDemo ? 'demo' : 'full'}`;
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    console.warn('[deal] Could not persist dealtHistory:', error);
  }
}

/**
 * Union of card IDs from the last N games for this department/mode.
 */
export function recentCardIds(departmentId, isDemo = false) {
  const store = readStore();
  const entry = store[historyKey(departmentId, isDemo)];
  const games = Array.isArray(entry?.games) ? entry.games : [];
  const ids = new Set();
  for (const game of games) {
    for (const id of game.cardIds || []) ids.add(id);
  }
  return [...ids];
}

/**
 * Append one finished game's dealt card IDs and trim to HISTORY_GAME_LIMIT.
 */
export function recordGameCards(departmentId, isDemo, cardIds) {
  const unique = [...new Set((cardIds || []).filter((id) => id != null))];
  if (unique.length === 0) return recentSnapshot(departmentId, isDemo);

  const store = readStore();
  const key = historyKey(departmentId, isDemo);
  const prev = store[key]?.games || [];
  const games = [...prev, { cardIds: unique, at: Date.now() }].slice(-HISTORY_GAME_LIMIT);
  store[key] = { demo: !!isDemo, games };
  writeStore(store);
  return store[key];
}

/** Last-5 snapshot for debug logging. */
export function recentSnapshot(departmentId, isDemo = false) {
  const store = readStore();
  return store[historyKey(departmentId, isDemo)] || { demo: !!isDemo, games: [] };
}
